import React from "react"
import { Container, Row, Col } from "reactstrap"
import Slider from "react-slick"

import Ticker from "../ticker"
import Animate from "../animate"

const list = [
  {
    familyName: "Аронов",
    name: "Александр Владимирович",
    image: "/images/team/aronov.jpg",
    position:
      "Председатель президиума коллегии «Аронов и Партнеры», Управляющий партнер",
    information:
      "Образование: МГЮА (специалист), ВШЭ (EMBA) Ученая степень: кандидат юридических наук Адвокат в реестре адвокатов города Москвы. Стаж работы по юридической специальности с 2003 года. "
  },
  {
    familyName: "Емелин",
    name: "Антон Евгеньевич",
    image: "/images/team/emelin.jpg",
    position: "Cтарший партнер",
    information:
      "Образование: МГУ (специалист), ГАУГН (специалист). Адвокат в реестре адвокатов города Москвы. Стаж работы по юридической специальности с 2003 года."
  },
  {
    familyName: "Нисанов",
    name: "Эдуард Нисонович",
    image: "/images/team/nisanov.jpg",
    position: "Партнер",
    information:
      "Образование: Российская академия народного хозяйства и государственной службы при Президенте Российской Федерации(специалист). Адвокат в реестре адвокатов города Москвы. Стаж работы по юридической специальности с 2020 года."
  },
  {
    familyName: "Ильин",
    name: "Александр Вячеславович",
    image: "/images/team/ilyin.jpg",
    position: "Партнер",
    information:
      "Образование: Московский физико-технический институт (специалист) Московский новый юридический институт (специалист). Ученая степень: кандидат юридических наук Адвокат в реестре адвокатов города Москвы. Стаж работы по юридической специальности с 1998 года."
  },
  {
    familyName: "Шадыева",
    name: "Замира Джоракулыевна",
    image: "/images/team/shadyieva.jpg",
    position: "Младший партнер",
    information:
      "Образование: Российский государственный университет нефти и газа им И.М. Губкина (специалист) Российская академия адвокатуры и нотариата (повышение квалификации). Адвокат в реестре адвокатов города Москвы Стаж работы по юридической специальности с 2013 года "
  },
  {
    familyName: "Вагнер",
    name: "Виктория Викторовна",
    image: "/images/team/vagner.jpg",
    position: "Младший партнер",
    information:
      "Образование: Финансовый Университет при Правительстве РФ специальность (юриспруденция). Профессиональная переподготовка по программе «Антикризисное управление». Стаж работы по юридической специальности с 2007 года. "
  },
  {
    familyName: "Курбацкая",
    name: "Нина Игоревна",
    image: "/images/team/kurbatskaya.jpg",
    position: "Младший партнер",
    information:
      "Образование: Российская Академия адвокатуры и нотариата им. Плевако (среднее профессиональное образование) Российская Академия адвокатуры и нотариата им. Плевако (специалист). Стаж работы: с 2008 года."
  }
]

const TeamSection = ({ title }) => {
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          dots: true
        }
      },
      {
        breakpoint: 685,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: false,
          dots: true
        }
      }
    ]
  }

  return (
    <section className="section section_team" id="team">
      <Container>
        <h2 className="section_title">{title}</h2>

        <div className="section_team__group">
          <Row>
            <Col md={8}>
              <div className="section_team__image">
                <Animate className="slide-up">
                  <img src="/images/team/team.jpg" alt={title} width="796px" />
                </Animate>
              </div>
            </Col>
            <Col md={4}>
              <Animate className="slide-up delay-2">
                <div className="card">
                  <div className="list_item__row">
                    <h5>Средняя цена иска в Аронов и партнеры</h5>
                    <div className="list_item__value">
                      <Ticker end={150000000} duration={1} /> руб
                    </div>
                  </div>
                  <div className="list_item__row">
                    <h5>Опыт в практике недвижимости</h5>
                    <div className="list_item__value">
                      <Ticker
                        startNum={1}
                        end={15}
                        duration={1.2}
                        delay={0.2}
                      />{" "}
                      лет
                    </div>
                  </div>
                  <div className="list_item__row">
                    <h5>
                      Находимся в рейтинге лучших юридических фирм Росии
                      Право300
                    </h5>
                    <div className="list_item__value">
                      <Ticker startNum={1} end={3} duration={1.3} delay={0.3} />{" "}
                      года подряд
                    </div>
                  </div>
                </div>
              </Animate>
            </Col>
          </Row>
        </div>

        <Animate className="slide-up delay-3">
          <Row>
            <Col md={8}>
              <p className="lead">
                Всем юридическим сопровождением занимается команда
                профессиональных адвокатов Московской коллегии адвокатов «Аронов
                и Партнеры», которая уже более трех лет подряд входит в рейтинг
                лучших юридических фирм в России по данным самого объективного
                рейтинга юридических фирм Право300.
              </p>

              <ul className="list_styled">
                <li>
                  Наши юристы имеют опыт работы в крупнейших российских и
                  международных компаниях и финансово-промышленных холдингах.
                </li>
                <li>У большинства членов команды есть ученые степени.</li>
                <li>
                  Все адвокаты коллегии занимаются научной и преподавательской
                  деятельностью в престижных юридических вузах России.
                </li>
              </ul>
            </Col>
          </Row>
        </Animate>

        <hr />

        <div className="team_slider">
          <Slider {...settings} className="slider row">
            {list.map((item, i) => (
              <div key={i} className="team_item col">
                <Animate className={`slide-up delay-${i + 1}`}>
                  <>
                    <div className="team_item__image">
                      <img
                        src={item.image}
                        alt={item.familyName}
                        width="300px"
                        height="200px"
                      />
                    </div>
                    <h4 className="team_item__title">
                      {item.familyName} <br />
                      {item.name}
                    </h4>
                    <div className="team_item__position">{item.position}</div>
                    {item.information && (
                      <div className="team_item__information">
                        {item.information}
                      </div>
                    )}
                  </>
                </Animate>
              </div>
            ))}
          </Slider>
        </div>
      </Container>
    </section>
  )
}

export default TeamSection
